export const categories = [
  {
    slug: 'electronic-games',
    name: '电子游艺',
    description: '汇聚全球顶尖电子游艺设备，高清画质、流畅操作，为您打造沉浸式娱乐体验。从经典老虎机到创新电子桌面游戏，应有尽有。',
    icon: 'ri-gamepad-line',
    image: 'https://readdy.ai/api/search-image?query=Elegant%20luxurious%20casino%20electronic%20gaming%20machines%20with%20warm%20golden%20ambient%20lighting%2C%20premium%20dark%20background%20with%20subtle%20gold%20accents%2C%20modern%20sleek%20slot%20machine%20design%2C%20sophisticated%20entertainment%20atmosphere%2C%20soft%20bokeh%20lights%2C%20high-end%20gaming%20lounge%20aesthetic%2C%20polished%20surfaces%2C%20refined%20color%20palette&width=800&height=600&seq=category-electronic-01&orientation=landscape',
  },
  {
    slug: 'live-casino',
    name: '真人视讯',
    description: '实时真人荷官在线发牌，高清视频直播，真实赌场氛围。百家乐、轮盘、骰宝等多种经典玩法，让您身临其境。',
    icon: 'ri-live-line',
    image: 'https://readdy.ai/api/search-image?query=Luxurious%20live%20casino%20dealer%20table%20with%20professional%20dealers%20in%20elegant%20attire%2C%20warm%20golden%20lighting%2C%20premium%20dark%20wood%20table%20with%20playing%20cards%20and%20chips%2C%20sophisticated%20casino%20atmosphere%2C%20soft%20ambient%20glow%2C%20refined%20entertainment%20setting%2C%20high-end%20interior%20design&width=800&height=600&seq=category-live-01&orientation=landscape',
  },
  {
    slug: 'sports-betting',
    name: '体育竞技',
    description: '覆盖全球各大体育赛事，足球、篮球、网球等丰富投注选项。实时赔率更新，专业数据分析，助您精准投注。',
    icon: 'ri-football-line',
    image: 'https://readdy.ai/api/search-image?query=Dynamic%20sports%20stadium%20atmosphere%20with%20dramatic%20stadium%20lights%2C%20professional%20soccer%20field%20with%20golden%20evening%20light%2C%20energetic%20sports%20vibe%2C%20premium%20dark%20background%20with%20golden%20accents%2C%20athletic%20elegance%2C%20sophisticated%20sports%20aesthetic&width=800&height=600&seq=category-sports-01&orientation=landscape',
  },
  {
    slug: 'card-games',
    name: '棋牌游戏',
    description: '经典棋牌游戏一网打尽，斗地主、麻将、德州扑克、牛牛等热门玩法。智能匹配对手，公平竞技环境。',
    icon: 'ri-bilibili-line',
    image: 'https://readdy.ai/api/search-image?query=Elegant%20poker%20cards%20and%20mahjong%20tiles%20arranged%20on%20dark%20velvet%20table%2C%20warm%20golden%20ambient%20lighting%2C%20luxurious%20game%20room%20atmosphere%2C%20premium%20playing%20cards%20with%20gold%20foil%20details%2C%20sophisticated%20entertainment%20setting%2C%20rich%20textures&width=800&height=600&seq=category-card-01&orientation=landscape',
  },
  {
    slug: 'lottery',
    name: '彩票游戏',
    description: '丰富彩票玩法，高频开奖、高额奖金。时时彩、十一选五、PK10等多种类型，让每一次投注都充满期待。',
    icon: 'ri-ticket-line',
    image: 'https://readdy.ai/api/search-image?query=Elegant%20lottery%20balls%20with%20golden%20numbers%20on%20dark%20velvet%20surface%2C%20warm%20ambient%20lighting%20with%20soft%20gold%20glow%2C%20premium%20lottery%20atmosphere%2C%20luxurious%20dark%20background%2C%20sophisticated%20design%20with%20golden%20accents%2C%20refined%20entertainment%20aesthetic&width=800&height=600&seq=category-lottery-01&orientation=landscape',
  },
  {
    slug: 'esports',
    name: '电竞游戏',
    description: '紧跟电竞潮流，覆盖英雄联盟、DOTA2、CS:GO等顶级赛事。实时比分直播，专业赛事分析，电竞爱好者的最佳选择。',
    icon: 'ri-computer-line',
    image: 'https://readdy.ai/api/search-image?query=Futuristic%20esports%20arena%20with%20dramatic%20purple%20and%20gold%20stage%20lighting%2C%20professional%20gaming%20setup%20with%20high-end%20equipment%2C%20dark%20atmosphere%20with%20neon%20gold%20accents%2C%20competitive%20gaming%20vibe%2C%20premium%20esports%20venue%2C%20sophisticated%20tech%20aesthetic&width=800&height=600&seq=category-esports-01&orientation=landscape',
  },
];

export const activities = [
  {
    id: 1,
    title: '新会员首存礼包——充值即送888元',
    description: '新用户注册后首次充值任意金额，即可获得888元体验金大礼包。多重优惠叠加，助您快速开启娱乐之旅。',
    badge: '热门',
    endDate: '2026-09-30',
  },
  {
    id: 2,
    title: '每日签到领金币——连续签到奖励翻倍',
    description: '每日登录签到即可领取丰厚金币奖励，连续签到7天奖励翻倍，30天更有神秘大礼。坚持签到，福利不断。',
    badge: '进行中',
    endDate: '2026-12-31',
  },
  {
    id: 3,
    title: 'VIP会员专属回馈——每月18日会员日',
    description: '每月18日为盛世娱乐VIP会员专属日，享受双倍积分、专属客服、限量礼品等多重特权。VIP等级越高福利越丰厚。',
    badge: '限时',
    endDate: '2026-12-31',
  },
];